import React from "react";

interface LoadingSpinnerProps {
  spinnerSize?: "tiny" | "extra-small" | "small" | "medium" | "large" | "extra-large" | "huge";
  label: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ label }) => {
  return (
    <div className="flex items-center justify-center gap-2 p-2">
      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-primary" />
      {label && <span className="text-sm text-muted-foreground">{label}</span>}
    </div>
  );
};

export default LoadingSpinner;
